import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

const cloudResourceOverviewTabContent = EntityContentBlueprint.make({
  name: 'cloud-resource',
  params: {
    path: '/',
    title: 'Overview',
    group: 'overview',
    filter: { kind: 'CloudResource' },
    loader: () =>
      import('./components').then(m => <m.CloudResourceOverviewTab />),
  },
});

const cloudResourceRulesTabContent = EntityContentBlueprint.make({
  name: 'cloud-resource-rules',
  params: {
    path: '/rules',
    title: 'Rules',
    group: 'rules',
    filter: { kind: 'CloudResource' },
    loader: () =>
      import('./components').then(m => <m.CloudResourceRulesTab />),
  },
});

const insightOverviewTabContent = EntityContentBlueprint.make({
  name: 'insight',
  params: {
    path: '/',
    title: 'Overview',
    group: 'overview',
    filter: { kind: 'Insight' },
    loader: () => import('./components').then(m => <m.InsightOverviewTab />),
  },
});

const ruleOverviewTabContent = EntityContentBlueprint.make({
  name: 'rule-overview',
  params: {
    path: '/',
    title: 'Overview',
    group: 'overview',
    filter: { kind: 'Rule' },
    loader: () => import('./components').then(m => <m.RuleOverviewTab />),
  },
});

const ruleResourcesTabContent = EntityContentBlueprint.make({
  name: 'rule-resources',
  params: {
    path: '/resources',
    title: 'Resources',
    group: 'resources',
    filter: { kind: 'Rule' },
    loader: () => import('./components').then(m => <m.RuleResourcesTab />),
  },
});

const ruleSetOverviewTabContent = EntityContentBlueprint.make({
  name: 'rule-set-overview',
  params: {
    path: '/',
    title: 'Overview',
    group: 'overview',
    filter: { kind: 'RuleSet' },
    loader: () => import('./components').then(m => <m.RuleSetOverviewTab />),
  },
});

const ruleSetRulesTabContent = EntityContentBlueprint.make({
  name: 'rule-set-rules',
  params: {
    path: '/rules',
    title: 'Rules',
    group: 'rules',
    filter: { kind: 'RuleSet' },
    loader: () => import('./components').then(m => <m.RuleSetRulesTab />),
  },
});

const projectCloudResourcesTabContent = EntityContentBlueprint.make({
  name: 'project-cloud-resources',
  params: {
    path: '/cloud-resources',
    title: 'Resources',
    group: 'resources',
    filter: { kind: 'Domain' },
    loader: () =>
      import('./components').then(m => <m.ProjectCloudResourcesTab />),
  },
});

const projectAccountsTabContent = EntityContentBlueprint.make({
  name: 'project-accounts',
  params: {
    path: '/accounts',
    title: 'Accounts',
    group: 'accounts',
    filter: { kind: 'Domain' },
    loader: () => import('./components').then(m => <m.ProjectAccountsTab />),
  },
});

const projectComplianceTabContent = EntityContentBlueprint.make({
  name: 'project-compliance',
  params: {
    path: '/compliance',
    title: 'Compliance',
    group: 'rules',
    filter: { kind: 'Domain' },
    loader: () =>
      import('./components').then(m => <m.ProjectComplianceTab />),
  },
});

const accountCloudResourcesTabContent = EntityContentBlueprint.make({
  name: 'account-cloud-resources',
  params: {
    path: '/cloud-resources',
    title: 'Resources',
    group: 'resources',
    filter: { kind: 'Account' },
    loader: () =>
      import('./components').then(m => <m.AccountCloudResourcesTab />),
  },
});

const accountInsightsTabContent = EntityContentBlueprint.make({
  name: 'account-insights',
  params: {
    path: '/insights',
    title: 'Insights',
    group: 'insights',
    filter: { kind: 'Account' },
    loader: () => import('./components').then(m => <m.AccountInsightsTab />),
  },
});

// Finance/Security/Housekeeping tabs merged into one Compliance tab —
// see design/compliance-page-mockup.html.
const accountComplianceTabContent = EntityContentBlueprint.make({
  name: 'account-compliance',
  params: {
    path: '/compliance',
    title: 'Compliance',
    group: 'rules',
    filter: { kind: 'Account' },
    loader: () =>
      import('./components').then(m => <m.AccountComplianceTab />),
  },
});

export default [
  cloudResourceOverviewTabContent,
  cloudResourceRulesTabContent,
  insightOverviewTabContent,
  ruleOverviewTabContent,
  ruleResourcesTabContent,
  ruleSetOverviewTabContent,
  ruleSetRulesTabContent,
  projectCloudResourcesTabContent,
  projectAccountsTabContent,
  projectComplianceTabContent,
  accountCloudResourcesTabContent,
  accountInsightsTabContent,
  accountComplianceTabContent,
];
